module.exports = __webpack_public_path__ + "media/images/online_talks/EB-f5d96a03414911dddb198d3dbfbc365d.png";